(function(konto) {
	konto.iz = {};
}(window.konto));
